/* Return to the Wild — scroll reveals.
   Guarded so duplicate <script src> tags (one per section) execute once. */
(function () {
  if (window.__rtwRevealInit) {
    return;
  }
  window.__rtwRevealInit = true;

  function revealAll() {
    var nodes = document.querySelectorAll('[data-rtw-reveal]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.add('rtw-reveal--in');
    }
  }

  var reducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion || !('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) {
          continue;
        }
        entries[i].target.classList.add('rtw-reveal--in');
        observer.unobserve(entries[i].target);
      }
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.1 }
  );

  function bind(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('.rtw');
    for (var s = 0; s < sections.length; s++) {
      var targets = sections[s].querySelectorAll('[data-rtw-reveal]');
      for (var t = 0; t < targets.length; t++) {
        if (targets[t].dataset.rtwBound === 'true') {
          continue;
        }
        targets[t].dataset.rtwBound = 'true';
        targets[t].style.setProperty('--rtw-delay', Math.min(t, 6) * 90 + 'ms');
        observer.observe(targets[t]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bind();
    });
  } else {
    bind();
  }

  /* Theme editor re-renders sections in place. */
  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
})();
